export default "__VITE_ASSET__9c86aa74__"